import { motion } from "framer-motion";

const chapters = [
  {
    n: "01",
    title: "Local knowledge, genuinely local.",
    body: "Based in the Blue Mountains, not commuting to them. Daniel knows which lookout catches the morning light, which road floods after rain, and which cellar door saves you a table.",
  },
  {
    n: "02",
    title: "Punctuality is a promise.",
    body: "Your driver arrives before you do. Flights are tracked live, wedding timelines are planned twice, and Jenolan's tour times are never missed — because waiting is the one luxury we don't sell.",
  },
  {
    n: "03",
    title: "Comfort for the mountains.",
    body: "Seven proper seats, room for luggage and walking poles, climate control for four-seasons-in-a-day weather, and a cabin kept immaculate between every journey.",
  },
];

export default function Manifesto() {
  return (
    <section
      id="manifesto"
      className="py-32 border-t border-white/10 bg-[#070707]"
      data-testid="manifesto-section"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.9 }}
          className="mb-24"
        >
          <p className="text-xs tracking-[0.35em] uppercase text-[#d4af37] mb-6">
            The Manifesto
          </p>
          <h2 className="font-serif-lux text-3xl sm:text-4xl lg:text-5xl font-light tracking-tight max-w-2xl">
            Three chapters. One standard.
          </h2>
        </motion.div>

        <div className="space-y-24">
          {chapters.map((c, i) => (
            <motion.div
              key={c.n}
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-100px" }}
              transition={{ duration: 0.9, delay: 0.05 * i }}
              className="grid grid-cols-1 md:grid-cols-12 gap-8 items-start"
              data-testid={`manifesto-chapter-${c.n}`}
            >
              <span className="md:col-span-3 font-serif-lux text-7xl lg:text-8xl font-light text-[#d4af37]/30 leading-none">
                {c.n}
              </span>
              <div className="md:col-span-9">
                <h3 className="font-serif-lux text-3xl sm:text-4xl font-light tracking-tight mb-6">
                  {c.title}
                </h3>
                <p className="max-w-2xl text-base leading-relaxed tracking-wide text-[#888]">
                  {c.body}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
